import React, { useContext, useRef } from "react";
import classes from "./DefaultSlider.module.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import EventCard from "../EventCard/EventCard";
import { Link, useLocation, useNavigate } from "react-router-dom";
import useWindowWidth from "helpers/useWindowWidth";
import { NavigationContext } from "App";

function extendArrayToTargetLength(array, targetLength) {
  if (
    !Array.isArray(array) ||
    array.length !== 3 ||
    !Number.isInteger(targetLength) ||
    targetLength < array.length
  ) {
    return array; // Return unchanged if invalid input
  }

  const extendedArray = [...array];
  const itemsToAdd = targetLength - array.length;
  for (let i = 0; i < itemsToAdd; i++) {
    const sourceIndex = i % array.length; // Cycle through original items
    extendedArray.push({
      ...array[sourceIndex],
      _id: `${array[sourceIndex]._id}-dup${i + 1}`,
    });
  }

  return extendedArray;
}

function DefaultSlider({ data, title, containerClass }) {
  const outerContainerWidth = (88 * window.innerWidth) / 100;
  const cardWidth = 630;
  const gapBetweenCards = 15;
  const customArrow = "/img/right-arrow.svg";
  console.log("data value is", data);
  const width = useWindowWidth();
  const { setIsBackNavigation } = useContext(NavigationContext);
  const sessionStore = "home";
  const navigate = useNavigate();
  const location = useLocation();

  const sliderRef = useRef(null);
  const mappingData = data?.listingItems?.length ? data?.listingItems : data;
  const displayFactor =
    width > 1800 ? 5 : width > 1500 ? 4 : width > 1110 ? 3 : width > 650 ? 2 : 1;

  const numCardsToShow =
    (outerContainerWidth + gapBetweenCards) / (cardWidth + gapBetweenCards);

  // Slider settings
  const settings = {
    dots: false,
    infinite: mappingData?.length > numCardsToShow,
    speed: 500,
    slidesToShow:
      mappingData?.length <= numCardsToShow
        ? mappingData?.length
        : numCardsToShow,
    slidesToScroll: 1,
    autoplay: mappingData?.length > numCardsToShow,
    // autoplay: false,
    autoplaySpeed: 4000,
    margin: 15,
    centerMode: false,
    variableWidth: true,
  };

  const handleNextArrowClick = () => {
    if (sliderRef.current) {
      sliderRef.current.slickNext();
    }
  };

  const handlePreviousArrowClick = () => {
    if (sliderRef.current) {
      sliderRef.current.slickPrev();
    }
  };

  function createSlug(title) {
    return title
      .toLowerCase()
      .trim()
      .replace(/\s+/g, "-")
      .replace(/[^a-z0-9-]/g, "")
      .replace(/--+/g, "-");
  }

  console.log('default location', location.pathname)

  // Common card rendering logic
  const renderCards = () =>
    mappingData?.map((card, index) => (
      <div key={index} className={classes.cardContainer}>
        {/* <Link to={`/${createSlug(card.categoryName)}/${card.slug}`}> */}
        <div style={{cursor: "pointer"}} onClick={()=>{
          if(location.pathname == "/"){
          const yPos = window.scrollY;
              sessionStorage.setItem("scrollTargetY", yPos.toString());
              sessionStorage.setItem("scrollOrigin", sessionStore); // or "branch" depending on the page
              setIsBackNavigation(true)
          }
          navigate(`/${createSlug(card.categoryName)}/${card.slug}`)}} >
          <EventCard
            listingId={card._id}
            image={card?.images?.[0] || card?.img}
            title={card.name || card?.title}
            slug={card?.slug}
            review={card?.ratingAvg}
            reviewCount={card?.reviewCount}
            showPrice={card?.showPrice}
            city={card.location?.locationName || card?.city}
            state={card.state}
            price={
              card?.availableDates?.[0]?.intervals?.[0]?.price
                ? card?.availableDates?.[0]?.intervals?.[0]?.price
                : card?.price
                ? card?.price
                : ""
            }
            strikePrice={card.strikePrice}
            categoryName = {card?.categoryName}
            listingType = {card?.listingType}
          />
        </div>
      </div>
    ));

  return (
    <div className="default-slide">
      <div className={`${classes.venuesOuter} ${containerClass} wmt wmb`}>
        <h2
          className={classes.eventTitle}
          dangerouslySetInnerHTML={{ __html: title }}
        ></h2>

        {mappingData?.length > displayFactor ? (
          <>
            <img
              className={classes.rightArrow}
              onClick={handleNextArrowClick}
              src="/img/right-arrow.svg"
              alt="Next"
            />
            <img
              className={classes.leftArrow}
              onClick={handlePreviousArrowClick}
              src="/img/left-arrow.svg"
              alt="Previous"
            />
            <Slider {...settings} ref={sliderRef}>
              {renderCards()}
            </Slider>
          </>
        ) : (
          <div className={classes.cardList}>{renderCards()}</div>
        )}
      </div>
    </div>
  );
}

export default DefaultSlider;
